import { reportarError } from "./report";

/**
 * Engancha los dos avisos que el navegador da cuando algo se rompe fuera
 * de todo `try`/`catch` y fuera de React.
 *
 * Se instala una sola vez, en `main.tsx`, ANTES de montar la app: un error
 * al importar un módulo o al arrancar ocurre antes de que exista un solo
 * componente, y es justo el que deja la pantalla en blanco.
 *
 * ── Los dos eventos ──────────────────────────────────────────────────
 * · `error`               — una excepción que nadie atrapó, incluidos los
 *                           chunks de JavaScript que no bajaron.
 * · `unhandledrejection`  — un `await` que falló sin `catch`.
 *
 * Ninguno de los dos se cancela (`preventDefault`): el error sigue llegando
 * a la consola tal cual. Reportar es AÑADIR un testigo, no tapar la boca
 * del que ya estaba.
 */
export function instalarCapturaDeErrores(): void {
  window.addEventListener("error", (evento) => {
    reportarError(evento.error ?? evento.message, "global");
  });

  window.addEventListener("unhandledrejection", (evento) => {
    reportarError(evento.reason, "promesa");
  });
}
